// removed by extract-text-webpack-plugin
module.exports = {"pageRoot":"BlogPage__pageRoot__1FMLD","layoutWrapperMain":"BlogPage__layoutWrapperMain__2gTUx","mainTitleContainer":"BlogPage__mainTitleContainer__3u2t-","mainTitle":"BlogPage__mainTitle__3MrU_","errorText":"BlogPage__errorText__rcJwI","contentContainer":"BlogPage__contentContainer__3aSEB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BlogPage/BlogPage.css
// module id = 2292
// module chunks = 0